import Font from '@maxpreps/shared/styles/font';
import React from 'react';
import THEME from '../../styles/colors';
import StyledButton, {
  ButtonFill,
  ButtonTheme
} from '../../ui/Button/StyledButton';
import { SportIcon } from '../../ui/Icon/Icon';
import LoadingSpinner from '../../ui/LoadingSpinner/LoadingSpinner';
import Modal from '../../ui/Modal/Modal';
import CascadingSelect from '../../ui/Select/CascadingSelect';
import { ISelectProps } from '../../ui/Select/Select';
import StyledText from '../../ui/Text/StyledText';
import Mascot from '../Image/Mascot';
import { StyledModalContent, StyledTopColorBar } from './StyledPickerModal';

export enum PickerImageType {
  Mascot = 0,
  Sport = 1
}

export interface IPickerModalProps {
  onClose: () => void;
  isSubmitEnabled: boolean;
  submitHref?: string;
  onSubmit?: () => void;
  dropdownConfig: ISelectProps[];
  title: string;
  subTitle: string;
  imageType: PickerImageType;
  imageProps: any;
  isLoading?: boolean;
}

const getButtonProps = (onSubmit, onClose) => ({
  onClick: () => {
    onSubmit();
    onClose();
    return false;
  },
  type: 'submit'
});

const getAnchorProps = href => ({
  as: 'a',
  href
});

const PickerModal: React.FC<IPickerModalProps> = ({
  onClose,
  isSubmitEnabled,
  submitHref,
  onSubmit,
  dropdownConfig,
  title,
  subTitle,
  imageType,
  imageProps,
  isLoading
}) => {
  const submitButtonProps = onSubmit
    ? getButtonProps(onSubmit, onClose)
    : getAnchorProps(submitHref);

  return (
    <Modal onOutClick={onClose} maxWidth="300px" portalId="picker">
      <StyledModalContent>
        <StyledTopColorBar />

        {imageType === PickerImageType.Mascot && (
          <Mascot {...imageProps} size={72} name={title} />
        )}
        {imageType === PickerImageType.Sport && (
          <div className="icon-wrapper">
            <SportIcon {...imageProps} size={40} />
          </div>
        )}

        <StyledText className={Font.f18_bold} $color={THEME.text.primary}>
          {title}
        </StyledText>
        <StyledText
          as="div"
          className={Font.f14_tall}
          $color={THEME.text.tertiary}
          $margin="4px 0 16px"
        >
          {subTitle}
        </StyledText>

        <CascadingSelect configList={dropdownConfig} />

        {isLoading && <LoadingSpinner center />}

        <StyledButton
          $colorScheme={ButtonTheme.Theme}
          $fillMode={ButtonFill.Fill}
          disabled={!isSubmitEnabled}
          className="picker-form-btn submit"
          {...submitButtonProps}
        >
          Go To Page
        </StyledButton>
        <StyledButton
          $colorScheme={ButtonTheme.Theme}
          $fillMode={ButtonFill.Link}
          onClick={onClose}
          className="picker-form-btn"
        >
          Cancel
        </StyledButton>
      </StyledModalContent>
    </Modal>
  );
};

export default PickerModal;
